import { css } from "@emotion/css";
import { Divider, PopoverBasicHelp } from "@octopusdeploy/design-system-components";
import { StringHelper } from "@octopusdeploy/design-system-octopus-components";
import { borderRadius, borderWidth, space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ArgoCDApplicationSourceResource } from "@octopusdeploy/octopus-server-client";
import type { PropsWithChildren } from "react";
import { MissingSourceNameWarning } from "~/areas/infrastructure/components/ArgoCDInstances/components/GenerateArgoCDAnnotationsDrawer/components/MissingSourceNameWarning";
import { SourceTypeTag } from "~/areas/infrastructure/components/ArgoCDInstances/components/SourceTypeTag";
const styles = {
    sourceCard: css({
        boxShadow: themeTokens.shadow["extraSmall"],
        border: `${borderWidth[1]} solid ${themeTokens.color.border.primary}`,
        borderRadius: borderRadius["large"],
    }),
    sourceCardHeader: css({
        padding: space[16],
    }),
    sourceInfoContainer: css({
        display: "flex",
        flexDirection: "column",
        gap: space[12],
    }),
    sourceInfoRow: css({
        display: "flex",
        flexDirection: "row",
        gap: space[32],
        alignItems: "center",
        margin: 0,
    }),
    sourceInfoLabel: css({
        font: text.body.bold.medium,
        width: "100px",
    }),
    sourceInfoHelp: css({
        marginLeft: space[12],
    }),
    sourceCardInputContainer: css({
        width: "600px",
        display: "flex",
        flexDirection: "column",
        gap: space[16],
        padding: space[16],
    }),
    sourceCardTitle: css({
        font: text.body.bold.large,
        color: themeTokens.color.text.primary,
        marginTop: 0,
        marginBottom: space[16],
    }),
};
type SourceCardProps = PropsWithChildren<{
    source: ArgoCDApplicationSourceResource;
    isMultiSourceApplication: boolean;
    showMissingNameWarning: boolean;
    hideHeader: boolean;
}>;
export const SourceCard = (props: SourceCardProps) => {
    const { source, isMultiSourceApplication, showMissingNameWarning, hideHeader, children } = props;
    return (<div className={styles.sourceCard}>
            {!hideHeader && (<>
                    <div className={styles.sourceCardHeader}>
                        <p className={styles.sourceCardTitle}>{source.RepositoryUrl}</p>
                        <div className={styles.sourceInfoContainer}>
                            {(!StringHelper.isNullOrWhiteSpace(source.Name) || showMissingNameWarning) && (<div className={styles.sourceInfoRow}>
                                    <span className={styles.sourceInfoLabel}>
                                        Name
                                        {isMultiSourceApplication && (<span className={styles.sourceInfoHelp}>
                                                <PopoverBasicHelp description={"Octopus requires a source name for multi-source Argo CD applications."} placement={"right-start"}/>
                                            </span>)}
                                    </span>
                                    {showMissingNameWarning && StringHelper.isNullOrWhiteSpace(source.Name) ? <MissingSourceNameWarning showHelpLink={true}/> : <span>{source.Name}</span>}
                                </div>)}
                            <div className={styles.sourceInfoRow}>
                                <span className={styles.sourceInfoLabel}>Type</span>
                                <SourceTypeTag source={source}/>
                            </div>
                        </div>
                    </div>
                    <Divider />
                </>)}
            <div className={styles.sourceCardInputContainer}>{children}</div>
        </div>);
};
